import { InclusionContent } from "@silversea-ssc/ui-components-react"
import { InclusionCode, INTERNATIONAL_AIR_INCLUSION_CODES } from "@silversea-ssc/web-inclusions"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import * as A from "fp-ts/Array"
import {
    eqByInclusionInfographicTitle,
    inclusionContentByCode,
    orderByInclusionInfographicTitle,
} from "../../../app-core/features/_common/read-models/inclusions"
import { bulletRow, ReceiptSection } from "../types"
import { SelectedFareForReceipt } from "./buildReceiptSections"
import { gatewayLabel, included } from "./utils"

export const summaryForInclusions = (
    airIncluded: boolean,
    selectedFare: SelectedFareForReceipt,
    selectedGateway: string | undefined,
): readonly ReceiptSection[] => {
    const inclusionsSummary = F.pipe(
        selectedFare.inclusions,
        A.filter((code) => airIncluded || !isAirInclusionCode([code])),
        A.map(inclusionContentByCode(selectedFare.inclusionsContent)),
        A.compact,
        A.sort(orderByInclusionInfographicTitle),
        A.uniq(eqByInclusionInfographicTitle),
        A.map(infographicToRow(selectedGateway)),
    )

    return [
        {
            label: selectedFare.fareName,
            key: selectedFare.fareName,
            rows: inclusionsSummary,
            totalAmount: O.none,
            isPromotional: true,
        },
    ]
}

const isAirInclusionCode = (codes: InclusionCode[]): boolean =>
    F.pipe(
        codes,
        A.some((c) => (INTERNATIONAL_AIR_INCLUSION_CODES as InclusionCode[]).includes(c)),
    )

const infographicToRow = (selectedGateway: string | undefined) => (content: InclusionContent) => {
    const note = isAirInclusionCode(content.codes) && selectedGateway ? gatewayLabel(selectedGateway) : undefined

    return bulletRow({
        label: content.infographicTitle,
        amount: included,
        isPromotional: true,
        note,
        rows: [],
    })
}
